import React from 'react';
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Adatvédelmi nyilatkozat</h1>

      <p>
        Jelen Adatvédelmi nyilatkozat célja, hogy tájékoztatást nyújtson a <strong>Császár Travel Kft.</strong> (továbbiakban: Szolgáltató)
        által végzett adatkezelési tevékenységekről a <strong>csaszartravel.hu</strong> weboldalon keresztül.
      </p>

      <h2>1. Az adatkezelő adatai</h2>
      <p><strong>Név:</strong> Császár Travel Kft.</p>
      <p><strong>Székhely:</strong> 8868 Murarátka, Hunyadi János utca 1.</p>
      <p><strong>Email:</strong> info@csaszartravel.hu</p>
      <p><strong>Telefon:</strong> +36 30 182 72 02</p>

      <h2>2. Kezelt adatok köre</h2>
      <p>Az alábbi személyes adatokat kérjük a weboldal különböző funkcióihoz:</p>
      <ul>
        <li>Utazásra jelentkezés: név, email cím, telefonszám, utazók száma, üzenet</li>
        <li>Hírlevél-feliratkozás: email cím</li>
        <li>Weboldal használatával kapcsolatos technikai adatok: IP-cím, böngésző típusa, cookie azonosítók</li>
      </ul>

      <h2>3. Adatkezelés célja és jogalapja</h2>
      <ul>
        <li>Utazásra történő jelentkezés kezelése – az Ön hozzájárulása alapján</li>
        <li>Kapcsolattartás – jogos érdek</li>
        <li>Hírlevél küldése – hozzájárulás alapján</li>
        <li>Weboldal működésének biztosítása (cookie-k) – jogos érdek / hozzájárulás</li>
      </ul>

      <h2>4. Adattárolás időtartama</h2>
      <ul>
        <li>A jelentkezések adatait <strong>30 napig</strong> tároljuk, ezt követően automatikusan töröljük.</li>
        <li>Hírlevélre feliratkozott email címek a leiratkozásig kerülnek tárolásra.</li>
      </ul>

      <h2>5. Adatokhoz való hozzáférés és továbbítás</h2>
      <p>
        Az adatokhoz kizárólag a Szolgáltató illetékes munkatársai férhetnek hozzá. Harmadik félnek az adatokat nem adjuk át, kivéve jogszabályi kötelezettség esetén.
      </p>

      <h2>6. Az érintettek jogai</h2>
      <ul>
        <li>Tájékoztatáshoz való jog</li>
        <li>Hozzáféréshez való jog</li>
        <li>Helyesbítéshez való jog</li>
        <li>Törléshez való jog („az elfeledtetéshez való jog”)</li>
        <li>Adatkezelés korlátozásához való jog</li>
        <li>Adathordozhatósághoz való jog</li>
        <li>Tiltakozáshoz való jog</li>
      </ul>
      <p>
        Kérés esetén az <strong>csaszar.business@gmail.com</strong> címen tud élni jogaival.
      </p>

      <h2>7. Cookie-k kezelése</h2>
      <p>
        A weboldal cookie-kat használ a működéshez és a látogatottsági statisztikák méréséhez.
        A cookie-k engedélyezése nem kötelező, de bizonyos funkciók enélkül nem működnek megfelelően.
      </p>

      <h2>8. Jogorvoslati lehetőségek</h2>
      <p>
        Panasz esetén fordulhat a Nemzeti Adatvédelmi és Információszabadság Hatósághoz (NAIH):<br />
        <strong>Cím:</strong> 1055 Budapest, Falk Miksa utca 9-11.<br />
        <strong>Web:</strong> <a href="https://www.naih.hu" target="_blank" rel="noopener noreferrer">www.naih.hu</a><br />
        <strong>Telefon:</strong> +36 (1) 391-1400
      </p>

      <p><strong>Utolsó frissítés:</strong> 2025. április</p>
    </div>
  );
};

export default PrivacyPolicy;
